exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-sp{border:8px solid #d0e3f0;border-radius:50%;border-top:8px solid #0294ff;width:50px;height:50px;-webkit-animation:spin-sp 1s linear infinite;animation:spin-sp 1s linear infinite;margin:0 auto;position:relative;margin:1rem auto}@keyframes spin-sp{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes spin-sp{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-589af073","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/super-checkout-intern/index.vue
// module id = egJ3
// module chunks = 0